import ApiUrls from "../../service/api/ApiUrls";
import ApiService from "../../service/api/ApiService";
import { AppConfigureModel } from "../../model/app_config/AppConfigModel";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import CacheStorage from "../../service/storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import OnboardingProvider from "../onboarding/onboarding/OnboardingProvider";
import AppConfigService from "../../service/app_config/AppConfigService";
import { appRoutes } from "../../routes/routes";

interface setupTheme {
  companyCode: string;
  baseUrlStatus?: boolean;
  loginStatus?: boolean | false;
  duration?: number | 0;
}

const APP_DEFAULT_TOKEN: string =
  process.env.REACT_APP_token_default ?? "030723553bff7";

const AppConfigurationProvider = new (class AppConfigurationProvider {
  setupTheme = async (params: setupTheme) => {
    console.log(`setupTheme baseUrl: ${params.baseUrlStatus ?? ""}`);
    const companyCode: string = params.companyCode;

    const url: string = `${
      params.baseUrlStatus ? ApiUrls.baseUrlCompany : ApiUrls.defaultUrlCompany
    }check_company_code`;
    const body: any = {
      api_token: APP_DEFAULT_TOKEN.toString(),
      company_code: companyCode.toString(),
    };
    const response: any = await ApiService.postApi(url, body, true);

    if (response !== null && response["success"] === "1") {
      const launchStatus: string =
        CacheStorage.getValue(StorageKeys.launch_status) || "0";
      if (launchStatus === "0") {
        const appConfigureModel: AppConfigureModel = response;
        const companyBaseUrl: string =
          appConfigureModel.result?.company_code_details!
            .company_app_base_url ?? "";

        // SAVE THEME
        AppConfigService.init(appConfigureModel.result?.company_code_details);

        if (
          UtilityHelper.isNotEmpty(companyBaseUrl) &&
          companyBaseUrl !== ApiUrls.defaultBaseUrl &&
          !params.baseUrlStatus
        ) {
          await this.setupTheme({
            companyCode: companyCode,
            baseUrlStatus: true,
          });
        } else {
          // register device
          await OnboardingProvider.registerDevice(companyCode);

          //
          if (params.loginStatus) {
            this.redirectLogic(companyCode, params.duration ?? 0);
          }
        }
      } else {
        if (params.loginStatus) {
          this.redirectLogic(companyCode, params.duration ?? 0);
        }
      }
    } else {
      // redirect to site
      //UtilityHelper.redirectToSite();
      window.location.replace(appRoutes.routeNameBoarding);
    }
  };

  redirectLogic = (companyCode: string, delay: number) => {
    setInterval(() => {
      AppConfigService.init();
      OnboardingProvider.launchLogic(companyCode);
    }, (delay + 2) * 1000);
  };
})();

export default AppConfigurationProvider;
